export default {
  state: {
    lang: 'ro',
    languages: [
      {
        short: 'ro',
        long: 'romana',
        inter: 'romanian',
        flag: '\uD83C\uDDF7\uD83C\uDDF4'
      },
      {
        short: 'en',
        long: 'english',
        inter: 'english',
        flag: '\uD83C\uDDEC\uD83C\uDDE7'
      }
    ]
  },
  getters: {
    language: ({lang}) => lang,
    languages: ({languages}) => languages
  },
  mutations: {
    setLanguage: (state, lang) => state.lang = lang
  },
  actions: {
    setLanguage: ({commit}, lang) => Promise.resolve()
      .then(() => {
        commit('setLanguage', lang)
      })
  }
}
